import { average, maximum, minimum, sum, count, median, mode } from "../../data/statistics";

const AGGREGATORS = { average, maximum, minimum, sum, count, median, mode };

// Wraps the basic statistics functions into a uniform result shape
// so executePlan can treat every terminal tool the same way.
export function buildAggregateResult(tool, data, measure) {

  const fn = AGGREGATORS[tool];

  if (!fn) {
    return { success: false, error: `Unknown aggregate tool: ${tool}` };
  }

  if (!Array.isArray(data) || !data.length) {
    return { success: false, tool, measure, error: "No data available." };
  }

  const value = tool === "count" ? fn(data) : fn(data, measure);

  return {
    success: value !== null && value !== undefined,
    tool,
    measure: tool === "count" ? undefined : measure,
    value,
    rows: data.length,
  };
}
